import { GithubOutlined } from '@ant-design/icons';
import styled from 'types/theme.types';
import type { FC } from 'react';

type GithubLogoProps = {
  style?: React.CSSProperties;
  className?: string;
};

const GithubLogo: FC<GithubLogoProps> = props => <StyledGithubOutlined {...props} />;

const StyledGithubOutlined = styled(GithubOutlined)`
  color: var(--icon-primary-standalone);
  font-size: var(--scale-700);
`;

export default GithubLogo;
